var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#006AE3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.571 6.857h1.286V17.57h-1.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.056 7.552c0 1.845.787 2.724 2.658 4.023v-1.352C9.674 9.398 9.2 8.747 9.2 7.537c0-1.65 1.35-2.988 3.015-2.988s3.016 1.338 3.016 2.988c0 .541-.147 1.072-.428 1.535l-.445-1.879l-1.15.269l.91 3.746l3.737-.993l-.305-1.131l-1.667.442a4.1 4.1 0 0 0 .493-1.974c0-2.277-1.863-4.123-4.16-4.123s-4.16 1.846-4.16 4.123m8.318 8.897c0-1.846-.792-2.738-2.664-4.036v1.351c1.04.825 1.52 1.489 1.52 2.699c0 1.65-1.35 2.989-3.015 2.989S9.2 18.114 9.2 16.462c0-.56.155-1.085.427-1.533l.445 1.878l1.15-.268l-.91-3.746l-3.737.992l.306 1.132l1.667-.443a4.1 4.1 0 0 0-.493 1.975c0 2.277 1.862 4.123 4.16 4.123s4.159-1.846 4.159-4.123"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYfi);
export default __webpack_public_path__ + "static/media/yfi.e216c6525d989ebd9713f3df6184274e.svg";
export { ForwardRef as ReactComponent };